import { Box, Text } from '@qga/roo-ui/components';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import PackageHeroSummary from '@/components/PackageHeroSummary';
import PricePerTraveller from '@/components/PricePerTraveller';
import useAddDefaultFlightCharges from '@/v2/components/pages/PackageViewV2/hooks/useAddDefaultFlightPrices';
import { CommonApi } from '@/v2/services/types';
import PriceContainer from '../RoomOptions/components/RoomOption/components/CTA/components/PriceContainer';

export type OfferPriceProps = {
  offer: CommonApi.ParsedResponse.RoomOffer;
  originName?: string;
};

const OfferPrice = ({ offer, originName }: OfferPriceProps) => {
  const { searchQuery } = useSearchQuery();
  const { children, adults, infants } = searchQuery || {};
  const charges = useAddDefaultFlightCharges(offer.charges);

  return (
    <PriceContainer>
      {/* @ts-ignore */}
      <PackageHeroSummary searchQuery={searchQuery} showNights exact />
      <PricePerTraveller
        exactTotalPrice
        travellers={{ children, adults, infants }}
        perTraveller={charges?.perTraveller}
        total={charges?.total}
      />

      {originName && (
        <Box textAlign="right" color="text.body" mt={2}>
          <Text
            fontSize={['14px', null, '16px']}
            lineHeight={['20px', null, '24px']}
            letterSpacing="0.1px"
          >{`Departing ${originName}`}</Text>
        </Box>
      )}
    </PriceContainer>
  );
};

export default OfferPrice;
